import { useEffect } from 'react';

export function JsonLd({ data }) {
  useEffect(() => {
    const id = `jsonld-${Math.random().toString(36).slice(2, 9)}`;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => { const el = document.getElementById(id); if (el) el.remove(); };
  }, [data]);
  return null;
}

export function SeoMeta({ title, description, og, article, canonical, extra, hreflang }) {
  useEffect(() => {
    if (title) document.title = title;
    const tags = [];
    const set = (attr, key, val) => {
      if (!val) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', val);
      tags.push({ attr, key });
    };
    if (description) {
      set('name', 'description', description);
      set('name', 'twitter:description', description);
    }
    if (title) {
      set('name', 'twitter:title', title);
    }
    set('name', 'twitter:card', 'summary_large_image');
    if (og) {
      Object.entries(og).forEach(([k, v]) => v && set('property', `og:${k}`, v));
      if (og.image) set('name', 'twitter:image', og.image);
    }
    if (article) {
      Object.entries(article).forEach(([k, v]) => v && set('property', `article:${k}`, v));
    }
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
    if (hreflang) {
      hreflang.forEach(([lang, href]) => {
        let link = document.querySelector(`link[hreflang="${lang}"]`);
        if (!link) {
          link = document.createElement('link');
          link.setAttribute('rel', 'alternate');
          link.setAttribute('hreflang', lang);
          document.head.appendChild(link);
        }
        link.setAttribute('href', href);
      });
    }
    if (extra) extra.forEach(([attr, key, val]) => set(attr, key, val));
    return () => {};
  }, [title, description, og, article, canonical, extra, hreflang]);
  return null;
}
